import { render } from "./CompaniesRow.vue?vue&type=template&id=53be670c&scoped=true"
import script from "./CompaniesRow.vue?vue&type=script&lang=js"
export * from "./CompaniesRow.vue?vue&type=script&lang=js"

import "./CompaniesRow.vue?vue&type=style&index=0&id=53be670c&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53be670c"]])

export default __exports__